<div class="reviews-filter-container" [formGroup]="reviewsForm" *ngIf="!isBookingOverview">
  <mat-form-field>
    <mat-label>Date range</mat-label>
    <!-- Use matPrefix to position the image on the left side -->
    <span matPrefix (click)="openDatePicker()">
      <img src="../../../assets/images/icons-kpi-dashboard/shooting-schedule.png" alt="Date Icon"
        class="furniture-icon" />
    </span>
    <mat-date-range-input [rangePicker]="reviewsPicker" [min]="minDate" [max]="maxDate" (click)="openDatePicker()">
      <input matStartDate placeholder="Start date" formControlName="startDate"  aria-label="Start Date"/>
      <input matEndDate placeholder="End date" formControlName="endDate" (dateChange)="onDateRangeChange()" aria-label="End Date"
        (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
    </mat-date-range-input>
    <mat-date-range-picker #reviewsPicker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showServiceType">
    <mat-label>Category</mat-label>
    <!-- Use matPrefix to position the image on the left side -->
    <span matPrefix>
      <img src="../../../assets/images/icons-kpi-dashboard/customer-service.png" alt="Service Icon"
        class="furniture-icon" />
    </span>
    <mat-select formControlName="reviewCategory" multiple (selectionChange)="onCategorySelectionChange($event)"
      [compareWith]="compareCategories">
      <mat-option *ngFor="let category of rCategories" [value]="category.id">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="showStore">
    <mat-label>Store</mat-label>
    <span matPrefix>
      <img src="../../../assets/images/icons-kpi-dashboard/store-icon.png" alt="Booking Store" class="furniture-icon" />
    </span>
    <mat-select formControlName="reviewStore" (selectionChange)="onStoreSelectionChange($event)"
      [compareWith]="compareStores" [disabled]="isStoresLoading" [multiple]="true" #multiSelect>
      <mat-option *ngIf="!isStoresLoading" (click)="$event.stopPropagation()">
        <ngx-mat-select-search placeholderLabel="Search stores..." (input)="filterStores($event)" [value]="storeSearchTerm" ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let store of filteredStores" [value]="store.storeId">
        {{ store.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="card-container container" *ngIf="reviewCountData && !isBookingOverview">
  <mat-card class="card skill-card">
    <header class="skill-card__header">
      <mat-card-subtitle>Warranty requests</mat-card-subtitle>
    </header>
    <section class="skill-card__body">
      <p class="skill-card__title">{{ reviewCountData.complaints }} %</p>
    </section>
  </mat-card>

  <mat-card class="card skill-card">
    <header class="skill-card__header">
      <mat-card-subtitle>NPS Score</mat-card-subtitle>
    </header>
    <section class="skill-card__body">
      <p class="skill-card__title">{{ reviewCountData.npsScore }}</p>
    </section>
  </mat-card>

  <mat-card class="card skill-card">
    <header class="skill-card__header">
      <mat-card-subtitle>No of Reviews</mat-card-subtitle>
    </header>
    <section class="skill-card__body">
      <p class="skill-card__title">{{ reviewCountData.noofReviews }}</p>
    </section>
  </mat-card>

  <mat-card class="card skill-card">
    <header class="skill-card__header">
      <mat-card-subtitle>Reviews ({{ reviewCountData.reviewsAvg }}/5)</mat-card-subtitle>
    </header>
    <section class="skill-card__body">
      <h2 class="skill-card__title" *ngIf="reviewCountData.reviewsAvg === 0">
        {{ reviewCountData.reviewsAvg }}
      </h2>
      <h2 class="skill-card__title" *ngIf="reviewCountData.reviewsAvg !== 0">
        <span class="review-star-rating" [innerHTML]="reviewCountData.starRating">
        </span>
      </h2>
    </section>
  </mat-card>
</div>

<mat-card class="chart-card" *ngIf="!isBookingOverview">
  <mat-card-header>
    <h1>NPS Score</h1>
  </mat-card-header>
  <mat-card-subtitle>
    <div class="chart-contaier">
      <app-reviews-percentile-grouped-by-store [startDate]="reviewsForm.controls['startDate'].value"
        [endDate]="reviewsForm.controls['endDate'].value" [categoryIds]="categories" [storeIds]="stores"
        [companyId]="companyId"></app-reviews-percentile-grouped-by-store>
    </div>
  </mat-card-subtitle>
</mat-card>

<!-- Data is available -->
<div class="example-table-container" *ngIf="!isBookingOverview">
  <table mat-table [dataSource]="sortedData" matSort (matSortChange)="handleSortChange($event)">
    <!-- Number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>No.</th>
      <td mat-cell *matCellDef="let row; let i = index;">{{ i + 1 }}</td>
    </ng-container>

    <!-- Execution Date Column -->
    <ng-container matColumnDef="creationDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation Date</th>
      <td mat-cell *matCellDef="let row">{{ row.creationDate }}</td>
    </ng-container>

    <!-- Service Column -->
    <ng-container matColumnDef="serviceType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Type</th>
      <td mat-cell *matCellDef="let row">
        <a mat-button class="service-type" (click)="overview(row.taskId)">{{
          row.serviceType
          }}</a>
      </td>
    </ng-container>

    <!-- Task Id Column -->
    <ng-container matColumnDef="taskId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Id</th>
      <td mat-cell *matCellDef="let row">{{ row.taskId }}</td>
    </ng-container>

    <!-- Store Column -->
    <ng-container matColumnDef="store">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Store</th>
      <td mat-cell *matCellDef="let row">
        {{ row.store }}
      </td>
    </ng-container>

    <!-- Execution Date Column -->
    <ng-container matColumnDef="reviewDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Review Date</th>
      <td mat-cell *matCellDef="let row">{{ row.reviewDate }}</td>
    </ng-container>

    <!-- rating Column -->
    <ng-container matColumnDef="rating">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Rating</th>
      <td mat-cell *matCellDef="let row">
        <div *ngIf="row.rating >= 0; else negativeRating" class="star-rating grid-star" [innerHTML]="row.starRating">
        </div>
        <ng-template #negativeRating>
          {{ row.ratingMessage }}
        </ng-template>
      </td>
    </ng-container>

    <!-- Review Column -->
    <ng-container matColumnDef="review">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Comment</th>
      <td mat-cell *matCellDef="let row" class="wrap-text">{{ row.review }}</td>
    </ng-container>

    <!-- Header Row and Data Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div *ngIf="sortedData.length === 0">No Data Available</div>

  <!-- Paginator -->
  <mat-paginator [length]="resultsLength" [pageIndex]="currentPageIndex" [pageSize]="currentPageSize"
    [pageSizeOptions]="[20, 50, 100, 200, 500]" (page)="onPageChange($event)" aria-label="Select page of results"
    class="paginator">
  </mat-paginator>
</div>

<app-review-overview *ngIf="isBookingOverview" [isLoading]="isLoading"
  (showBookingsData)="isBookingsData($event)"></app-review-overview>